import { useDashboardContext } from "@/context-state/DashboardContext.jsx";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { handleError } from "@/services/errorHandler.js";
import { getCreativeReports, getCreatives, getFolders, getIntegrations } from "@/services/api.js";
import { MainLoader } from '@/components/loader/MainLoader.jsx'
import { useParams } from 'react-router-dom'
import { toggleLoader } from '@/hooks/useDashboardLoader.jsx'

export const DashboardDataProvider = ({ children }) => {

    const { integrationsContext, creativeContext } = useDashboardContext()

    const { updateIntegrationsState } = integrationsContext
    const { updateCreativeState, setCreativeReports, updateFolderState } = creativeContext
    const { spaceId } = useParams()
    const [isFetched, setIsFetched] = useState(false)

    const fetchEssentialDashboardData = async () => {
        try {
            // Get essential data for the dashboard
            const [
                integrationsResponse,
                // creativesResponse,
                creativeReportsResponse,
                // foldersResponse,
            ] = await Promise.all([
                getIntegrations(),
                // getCreatives(), // TODO - this should moved to the library page so i will fetch the creatives per adAccountId and not all of them
                getCreativeReports(),
                // getFolders()
            ])


            // updateFolderState(foldersResponse.data)
            // updateCreativeState(creativesResponse.data)
            updateIntegrationsState(integrationsResponse.data)
            setCreativeReports(creativeReportsResponse.data)

            setIsFetched(true)
        } catch (e) {
            toast.error(e.message)
            console.log(e)
            handleError(e)
        }
    }

    // Needs to re fetch some data each time the space changes, we're currently not saving that to local state
    const handleSpaceChanged = async () => {
        try {
            toggleLoader(true)
            const { data } = await getCreativeReports()
            setCreativeReports(data)
        } catch (e) {
            toast.error(e.message)
            console.log(e)
            handleError(e)
        } finally {
            toggleLoader(false)
        }
    }

    useEffect(() => {
        if (!isFetched) {
            fetchEssentialDashboardData()
            return
        }
        handleSpaceChanged()
    }, [spaceId])



    return (
        isFetched ? children : <MainLoader className="bg-hero-background bg-cover bg-center bg-no-repeat" />
    )

}
